<template>
  <div class="min-h-screen bg-slate-100 flex items-center justify-center px-4">
    <div class="bg-white rounded-2xl shadow-md max-w-md w-full px-10 py-12 text-center">

      <!-- Icon -->
      <div class="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-6">
        <svg class="w-8 h-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/>
        </svg>
      </div>

      <h1 class="text-xl font-bold text-slate-800 mb-2">Invoice Not Available</h1>
      <p class="text-slate-500 text-sm leading-relaxed">
        This invoice is private and has not been shared publicly.<br>
        Please contact the sender for access.
      </p>

    </div>
  </div>
</template>
